import Colors from "../../theme/Colours";

export const buttonStyle = {
  borderRadius: { xs: "5px", sm: "60px" },
  bgColor: Colors.buttonBGColor,
  alignSelf: { xs: "center", sm: "flex-end" },
  height: { xs: "30px", sm: "48px" },
  width: { xs: "238px", sm: "248px" },
  mb: { xs: "30px", sm: "0px" },
  "&:hover": {
    backgroundColor: Colors.buttonBGColor, // Keeps the same background color on hover
  },
  padding: { xs: "18px 32px", sm: "10px 24px" },
  fontSize: { xs: "10px", sm: "18px" },
};

export const makePaymentButtonStyle = {
  ...buttonStyle,
  alignSelf: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "white",
  mb: 0,
  fontFamily: "Poppins",
  width: { xs: "150px", sm: "248px" },
  padding: { xs: "2px", sm: "10px 24px" },
};

export const buttonStyleSeller = {
  ...buttonStyle,
  width: "300px",
  borderRadius: "16px",
};

export const mainContainerStyle = {
  display: "flex",
  flexDirection: "column",
  backgroundColor: { xs: "none", sm: Colors.background2 },
  px: { xs: 0, sm: "24px" },
  py: { xs: "0px", sm: "30px" },
  boxShadow: { xs: "none", sm: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)" },
};

export const buttonContainerStyle = {
  display: "flex",
  justifyContent: "space-between",
  marginRight: "16px",
  gap: "16px",
};

export const cardContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: { xs: "10px 7px 10px 16px", sm: "24px 16px" },
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
  backgroundColor: Colors.background2,
  borderRadius: { xs: 0, sm: "8px" },
  marginBottom: "25px",
  gap: { xs: "9px", sm: "75px" },
};

export const cardMediaStyle = {
  width: { xs: "26px", sm: "67px" },
  height: { xs: "26px", sm: "67px" },
  borderRadius: "8px",
  flexShrink: 0,
};

export const textContainerStyle = {
  flexGrow: 1,
  "& .MuiTypography-root": {
    fontSize: { xs: "10px", sm: "18px", md: "24px" },
    fontWeight: 500,
  },
};
